import bodycare from '../images/bodycare.jpg';
import hair from '../images/hair.jpg';
import makeup from '../images/makeup.jpg';
import skincare from '../images/skincare.jpg';
import nails from '../images/nails.jpg';
import perfume from '../images/perfume.jpg';
import accessories from '../images/accessories.jpg';

export type Translation = {
    name: string;
    language: string;
}

export type Category = {
    value: string;
    image: any;
    translations: Translation[];
}

export const categories: Category[] = [
    { value: "makeup", image: makeup, translations: [{ name: "makijaż", language: "pl" }, { name: "makeup", language: "en" }] },
    { value: "skincare", image: skincare, translations: [{ name: "pielęgnacja twarzy", language: "pl" }, {name: "skincare", language: "en"}] },
    { value: "bodycare", image: bodycare, translations: [{ name: "pielęgnacja ciała", language: "pl" }, { name: "bodycare", language: "en"}] },
    { value: "hair", image: hair, translations: [{ name: "włosy", language: "pl" }, { name: "hair", language: "en"}] },
    { value: "nails", image: nails, translations: [{ name: "paznokcie", language: "pl" }, { name: "nails", language: "en"}] },
    { value: "perfume", image: perfume, translations: [{ name: "perfumy", language: "pl" }, { name: "perfume", language: "en"}] },
    { value: "accessories", image: accessories, translations: [{ name: "akcesoria", language: "pl" }, { name: "accessories", language: "en"}] },
];

